import { render, staticRenderFns } from "./webfontRenderer.vue?vue&type=template&id=585944e0&"
import script from "./webfontRenderer.vue?vue&type=script&lang=ts&"
export * from "./webfontRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports